module.exports = __webpack_public_path__ + "static/404-6008869ce1307721786deba7d745facb.png";